(function ($) {
  'use strict';
  this.ThisIsEnough = function () {};
}).bind(window)(jQuery);
